import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IWarehouseTransferInfo_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferInfo_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class WarehouseTransferInfo_ScreenBase extends React.PureComponent<
  IWarehouseTransferInfo_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "412ab2f1-1fc4-4772-9c52-d4eca2e65ea6",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 869753, PropertyName: "value", Value: "label" },
        { Id: 803531, PropertyName: "value", Value: "label" },
        { Id: 337787, PropertyName: "value", Value: "Sayılan Ürün Sayısı" },
        { Id: 383066, PropertyName: "value", Value: "label" },
        { Id: 538236, PropertyName: "value", Value: "Durum" },
        { Id: 332318, PropertyName: "value", Value: "label" },
        { Id: 483549, PropertyName: "value", Value: "Başlangıç Tarihi" },
        { Id: 531119, PropertyName: "value", Value: "label" },
        { Id: 988721, PropertyName: "value", Value: "Bitiş Tarihi" },
        { Id: 119724, PropertyName: "value", Value: "label" },
        { Id: 985769, PropertyName: "value", Value: "Gönderen Ofis Kodu" },
        { Id: 350135, PropertyName: "value", Value: "label" },
        { Id: 990263, PropertyName: "value", Value: "Gönderen Depo Kodu" },
        { Id: 982853, PropertyName: "value", Value: "label" },
        { Id: 318603, PropertyName: "value", Value: "Gelen Ofis Kodu" },
        { Id: 173773, PropertyName: "value", Value: "label" },
        { Id: 356042, PropertyName: "value", Value: "Gelen Depo Kodu" },
        { Id: 667931, PropertyName: "value", Value: "label" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("warehousetransferinfo", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("warehousetransferinfo", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("warehousetransferinfo", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
